import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { accountIdSelector } from '../../store/auth/auth.selectors';
import initRdiMFEApiService from './initRdiMFEApiService';

/**
 * Component that reinitializes API services when account ID becomes available.
 */
export const AccountIdAwareServiceInitializer = () => {
  const accountId = useSelector(accountIdSelector);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    initRdiMFEApiService();
  }, [accountId]);

  return null;
};
